// **********************************************************
//  specialisations-slider
// **********************************************************
/* eslint-disable */
$(function () {
  //  specialisationsSlider slider
  new Swiper('.specialisations-slider', {
    slidesPerView: 1,
    spaceBetween: 25,
    freeMode: true,
    navigation: {
      nextEl: '.specialisations-slider__nav-arrow.next',
      prevEl: '.specialisations-slider__nav-arrow.prev',
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1023: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 22,
      }
    },
  });
});
/* eslint-enable */
